import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
interface CTASectionProps {
  variant?: 'primary' | 'final';
}
export function CTASection({
  variant = 'primary'
}: CTASectionProps) {
  return <section id={variant === 'final' ? 'cta-final' : undefined} className={`w-full px-4 md:px-6 py-6 md:py-24 text-center ${variant === 'primary' ? 'bg-[#FFF8F0]' : 'bg-gradient-to-b from-[#FFF8F0] to-[#F5E6DC]'}`} data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-35">
          {variant === 'final' && <div className="mb-5 md:mb-12" data-id="element-36">
              <p className="text-2xl md:text-4xl font-['Playfair_Display'] font-bold text-[#2D2D2D] mb-3 md:mb-6 leading-tight" data-id="element-37">
                Tu negocio{' '}
                <span className="text-[#E8734A]" data-id="element-38">no puede esperar</span> a que
                te sientas lista.
              </p>
              <p className="text-lg md:text-xl text-[#2D2D2D] leading-relaxed mb-4 md:mb-10 font-medium max-w-xl mx-auto" data-id="element-39">
                Hoy puedes conseguir esa claridad en{' '}
                <span className="text-[#D4A853] font-bold" data-id="element-40">60 segundos</span>.
                Por $6.36. Con garantía. Sin riesgo.
              </p>
              <div className="bg-white p-4 md:p-6 rounded-xl md:rounded-2xl shadow-md border border-[#F5E6DC] max-w-lg mx-auto" data-id="element-41">
                <p className="text-lg md:text-2xl font-['Playfair_Display'] font-bold text-[#E8734A]" data-id="element-42">
                  ¿Cuántos días más vas a trabajar con el cerebro en niebla?
                </p>
              </div>
            </div>}

          <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl mb-5 md:mb-10 border border-[#F5E6DC] overflow-hidden" data-id="element-43">
            {/* Price header */}
            <div className="bg-[#2D2D2D] p-5 md:p-10 relative overflow-hidden" data-id="element-44">
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#E8734A] rounded-full opacity-10 blur-3xl" data-id="element-45" />

              <div className="relative z-10" data-id="element-46">
                <div className="relative inline-block mb-2 md:mb-3" data-id="element-47">
                  <span className="text-2xl md:text-4xl font-bold text-white/30" data-id="element-48">
                    $47 USD
                  </span>
                  <div className="absolute top-1/2 -left-2 -right-2 h-0.5 bg-red-500 -rotate-6 rounded-full" data-id="element-49" />
                </div>

                <div className="flex items-baseline justify-center gap-2 mb-2 md:mb-3" data-id="element-50">
                  <span className="text-5xl md:text-7xl font-black text-white" data-id="element-51">
                    $6.36
                  </span>
                  <span className="text-lg text-white/40 font-medium" data-id="element-52">USD</span>
                </div>

                <div className="inline-flex items-center gap-2 bg-[#D4A853] text-white px-4 md:px-5 py-1.5 md:py-2 rounded-full text-sm font-bold" data-id="element-53">
                  <span className="text-lg font-black" data-id="element-54">86%</span>
                  <span className="uppercase tracking-wide" data-id="element-55">de ahorro</span>
                </div>
              </div>
            </div>

            {/* CTA button + trust */}
            <div className="p-5 md:p-10" data-id="element-56">
              <p className="text-base md:text-lg text-[#2D2D2D] font-medium mb-3 md:mb-6 opacity-80" data-id="element-57">
                Todo por menos de lo que cuesta un café que ya no te hace efecto
              </p>

              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={() => window.open('https://pay.hotmart.com/X105440723H?checkoutMode=10', '_blank')} className="w-full bg-[#E8734A] hover:bg-[#d66539] text-white font-bold text-lg md:text-2xl py-4 md:py-6 px-5 md:px-8 rounded-xl shadow-xl flex items-center justify-center gap-2 md:gap-4 transition-colors mb-3 md:mb-6" data-id="element-58">
                {variant === 'final' ? 'SÍ, QUIERO MENTE CLARA AHORA' : 'QUIERO MENTE CLARA AHORA POR $6.36'}
                <ArrowRightIcon className="w-6 md:w-7 h-6 md:h-7" data-id="element-59" />
              </motion.button>

              <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-6 gap-y-2 md:gap-y-3 text-xs md:text-sm text-[#2D2D2D] font-bold" data-id="element-60">
                <span className="flex items-center gap-1.5 md:gap-2" data-id="element-61">
                  <CheckCircleIcon className="w-4 h-4 text-[#D4A853]" data-id="element-62" /> Acceso
                  inmediato
                </span>
                <span className="flex items-center gap-1.5 md:gap-2" data-id="element-63">
                  <CheckCircleIcon className="w-4 h-4 text-[#D4A853]" data-id="element-64" />{' '}
                  Descarga instantánea
                </span>
                <span className="flex items-center gap-1.5 md:gap-2" data-id="element-65">
                  <CheckCircleIcon className="w-4 h-4 text-[#D4A853]" data-id="element-66" />{' '}
                  Garantía de 7 días
                </span>
                <span className="flex items-center gap-1.5 md:gap-2" data-id="element-67">
                  <CheckCircleIcon className="w-4 h-4 text-[#D4A853]" data-id="element-68" /> Pago
                  100% seguro
                </span>
              </div>
            </div>
          </div>

          {variant === 'primary' && <div className="bg-[#2D2D2D] text-white rounded-xl md:rounded-2xl p-5 md:p-10 shadow-lg max-w-xl mx-auto" data-id="element-69">
              <p className="text-lg leading-relaxed mb-3 md:mb-4 font-medium opacity-90" data-id="element-70">
                Si recuperas apenas{' '}
                <span className="text-[#D4A853] font-bold" data-id="element-71">30 min</span> de
                enfoque al día...
              </p>
              <div className="flex justify-center gap-6 md:gap-8 mb-4 md:mb-6" data-id="element-72">
                <div data-id="element-73">
                  <p className="text-3xl font-black text-[#E8734A]" data-id="element-74">3.5h</p>
                  <p className="text-xs text-white/50 font-bold uppercase tracking-wide" data-id="element-75">
                    por semana
                  </p>
                </div>
                <div className="w-px bg-white/10" data-id="element-76" />
                <div data-id="element-77">
                  <p className="text-3xl font-black text-[#E8734A]" data-id="element-78">14h</p>
                  <p className="text-xs text-white/50 font-bold uppercase tracking-wide" data-id="element-79">
                    por mes
                  </p>
                </div>
              </div>
              <p className="text-lg font-bold text-[#D4A853]" data-id="element-80">
                ¿Cuánto valen 14 horas de mente clara para tu negocio?
              </p>
            </div>}
        </motion.div>
      </div>
    </section>;
}